import React from "react";
import { checkUserHasManagerRole } from "app/services/app.state.service";
import { LeavePlansForManager } from "app/components/leave-plans/LeavePlansForManager";
import { HolidayListView } from "./HolidayListView";
import { Grid } from "@mui/material";

export const LeavePlanManagerView = () => {

    if(!checkUserHasManagerRole()) {
        return <div>You do not have access to this functionality.</div>;
    }
    return (
        <div className="leave-plan-main-container">
            <Grid container spacing={6}>
                <LeavePlansForManager />
                <HolidayListView />
            </Grid>
        </div>
    );
}